<template>
  <div id="container" v-if="change_rank_info">
    <section id="mypage">
      <div class="wrap">

        <div class="cts_box">
          <h2 class="sub_ttl"><span>塾生クラスの変更</span></h2>
          <p class="lead_txt" v-if="change_rank_info.price === 0">
            以下の内容で塾生クラスの変更を行います。<br>
            内容に間違いがないかご確認のうえ、画面下の「変更を申請する」ボタンを押してください。
          </p>
          <p class="lead_txt" v-else-if="change_rank_info.total_price === 0">
            以下の内容で塾生クラスの変更を行います。<br>
            内容に間違いがないかご確認のうえ、画面下の「変更を申請する」ボタンを押してください。
          </p>
          <p class="lead_txt" v-else>
            以下の内容で塾生クラスの変更を行います。<br>
            内容に間違いがないかご確認のうえ、画面下の「決済情報を入力する」ボタンから決済画面へ進んで、差額の決済を行ってください。<br>
            （外部サイトへ移動します）
          </p>
        </div>

        <div class="cts_box">
          <h3 class="min_ttl">変更内容</h3>
          <div class="df_table">
            <dl class="flex">
              <dt>現在のクラスとお支払い方法</dt>
              <dd>
                {{ current_user.rank_name }}
                <template v-if="current_user.plan === 'plan_basic'">+ 四季報オンラインベーシック</template>
                <template v-if="current_user.plan === 'plan_premium'">+ 四季報オンラインプレミアム</template>
              </dd>
            </dl>
            <dl class="flex">
              <dt>変更後のクラス</dt>
              <dd>{{ change_rank_info.title }}</dd>
            </dl>
            <dl class="flex" v-if="false">
              <dt>変更後のお支払い方法</dt>
              <dd></dd><!--月額払い or 年額払い-->
            </dl>
            <dl class="flex" v-if="false">
              <dt>四季報ONLINE優待プラン</dt>
              <dd></dd><!--本科：加入プラン、本科プラス：変更後のクラスに「プレミアムプラン」が含まれます。-->
            </dl>
          </div>
        </div>

        <div v-bind:class="{ 'point-disabled': !change_rank_info.price }">

          <div class="cts_box">
            <h3 class="min_ttl">お会計内容</h3>
            <div class="register_box">
              <dl class="flex">
                <dt>{{ change_rank_info.title }} への変更</dt>
                <dd class="price">¥{{ delimited(change_rank_info.price) }}</dd>
              </dl>
              <dl class="flex" v-if="false">
                <dt>クーポンのご利用</dt>
                <dd class="item"></dd>
                <dd class="price">¥-6,500</dd>
              </dl>
              <dl class="flex" v-if="change_rank_info.use_point">
                <dt>ポイントのご利用</dt>
                <dd class="item"></dd>
                <dd class="price">-{{ delimited(change_rank_info.use_point) }}</dd>
              </dl>
              <dl class="flex total">
                <dt></dt>
                <dd class="item">お会計合計：</dd>
                <dd class="price">¥{{ delimited(change_rank_info.total_price) }}</dd>
              </dl>
            </div>
          </div>
        </div>

        <div class="btn_wrap mt20" v-if="change_rank_info.price === 0">
          <p class="alnC sp_alnL mb10">内容に変更なければ<br class="sp">こちらのボタンを押してください</p>
          <a href="javascript:void(0);" class="submit light arrow large sp_h_auto"
             v-bind:class="{disabled: !changeEnabled()}" @click="changeRank()">変更を申請する</a>
          <p class="alnC sp_alnL mt20 red bold" v-if="change_rank_info.level !== 'upgrade'">{{ moment(current_user.next_payment_date, 'YYYY年M月') }}のクラス変更の予約になります。即時変更ではありませんのでご注意ください。</p>
        </div>
        <div class="btn_wrap mt20" v-else-if="change_rank_info.total_price === 0">
          <p class="alnC sp_alnL mb10">内容に変更なければ<br class="sp">こちらのボタンを押してください</p>
          <a href="javascript:void(0);" class="submit light arrow large sp_h_auto"
             v-bind:class="{disabled: !changeEnabled()}" @click="changeRank()">変更を申請する</a>
          <p class="alnC sp_alnL mt20 red bold" v-if="change_rank_info.level !== 'upgrade'">{{ moment(current_user.next_payment_date, 'YYYY年M月') }}のクラス変更の予約になります。即時変更ではありませんのでご注意ください。</p>
        </div>
        <div class="cts_box" v-else>
          <div class="button_wrap">
            <p class="alnC mb20">
              内容に変更なければ<br class="sp">続いて代金の決済を行います
            </p>
            <a href="javascript:void(0);" class="submit light arrow large sp_h_auto"
               v-bind:class="{disabled: !changeEnabled()}" @click="changeRank()">決済情報を入力する
            </a>
            <div class="paygent flex">
              <img src="/common/images/paygent_logo.png" alt="PAYGENT">
              <p>
                クレジットカード決済サービス会社（PAYGENT）の決済画面に移動します。PAYGENTは、NTTデータと三菱UFJニコスの合弁による国内大手決済サービス会社です。
              </p>
            </div>
          </div>
        </div>

        <div class="btn_wrap mt40">
          <p class="alnC sp_alnL mb10">入力内容を変更する場合はこちらのボタンを押してください</p>
          <a href="javascript:void(0);" @click="$router.back()" class="submit light skeleton arrow back large">
            前のページにもどる
          </a>
        </div>

      </div>
    </section>

    <div id="b_listBox">
      <ul id="b_list">
        <li>
          <router-link to="/">トップページ</router-link>
        </li>
        <li>
          <router-link :to="{name: 'UsersCustomerAccount'}">マイページ</router-link>
        </li>
        <li>塾生クラスの変更</li>
      </ul>
    </div>
  </div>

</template>

<script>

import Libraries from '@/components/Libraries'

export default {
  mixins: [Libraries],
  data() {
    return {
      change_rank_info: null,
      request_exec: false,
    }
  },
  methods: {
    changeEnabled() {
      return this.current_user.rank !== this.change_rank_info.new_rank && this.change_rank_info.level !== 'error'
    },

    changeRank() {
      if (this.request_exec) return
      this.request_exec = true

      if (this.change_rank_info.price === 0) {
        if (!confirm('クラス・支払い方法の変更を申請しますか？')) {
          return
        }
      } else if (this.change_rank_info.total_price === 0) {
        if (!confirm('クラス変更を実施しますか？')) {
          return
        }
      } else {
        if (!confirm('クラス変更のための決済を実施しますか？')) {
          return
        }
      }
      // ランク変更実施
      this.startUpload()
      this.axios
          .post(`${this.env.api_base_url}users/change_rank.json`, {
            new_rank: this.change_rank_info.rank,
            use_points: this.change_rank_info.use_point,
            shikiho_account: this.change_rank_info.shikiho_account
          })
          .then((response) => {
            // console.log(response.data)
            // 必要なら決済開始
            if (response.data.url) {
              document.location.href = response.data.url
            } else if (response.data.message) {
              alert(response.data.message)
            } else {
              this.$router.push({name: 'UsersCustomerRankChangeFinish'})
            }
          })
          .catch((error) => {
            if (error.response.data.error) {
              alert(error.response.data.error)
            } else {
              this.errorAjax(error)
            }
          })
          .finally(() => {
            this.finishUpload()
            this.request_exec = false
          })
    }
  },

  mounted() {
    // form token
    if (!this.checkFormToken('RankChange')) return

    // 旧塾生専用のページ
    if (!this.$store.state.change_rank_info) {
      this.$router.push({name: 'UsersCustomerAccount'})
    } else {
      this.change_rank_info = this.$store.state.change_rank_info
      // console.log(this.change_rank_info)
    }
  }
}
</script>

<style>
.point-disabled {
  pointer-events: none;
  opacity: 0.5;
}
</style>